(function ($, Drupal) {
  Drupal.behaviors.aitSliderFilterComponent = {
    attach: function () {
      // Gets css property value of style attribute.
      function getStyle(el, styleProp) {
        var value, defaultView = (el.ownerDocument || document).defaultView;
        // W3C standard way:
        if (defaultView && defaultView.getComputedStyle) {
          // sanitize property name to css notation
          // (hypen separated words eg. font-Size)
          styleProp = styleProp.replace(/([A-Z])/g, "-$1").toLowerCase();
          return defaultView.getComputedStyle(el, null).getPropertyValue(styleProp);
        } else if (el.currentStyle) { // IE
          // sanitize property name to camelCase
          styleProp = styleProp.replace(/\-(\w)/g, function(str, letter) {
            return letter.toUpperCase();
          });
          value = el.currentStyle[styleProp];
          // convert other units to pixels on IE
          if (/^\d+(em|pt|%|ex)?$/i.test(value)) {
            return (function(value) {
              var oldLeft = el.style.left, oldRsLeft = el.runtimeStyle.left;
              el.runtimeStyle.left = el.currentStyle.left;
              el.style.left = value || 0;
              value = el.style.pixelLeft + "px";
              el.style.left = oldLeft;
              el.runtimeStyle.left = oldRsLeft;
              return value;
            })(value);
          }
          return value;
        }
      }
      let ready = (callback) => {
        if (document.readyState != "loading") callback();
        else document.addEventListener("DOMContentLoaded", callback);
      }
      ready(() => {
        // Set slider element background according to the drag element position.
        let element = document.querySelector('span.ui-slider-handle.ui-corner-all.ui-state-default');
        let element_to_change = document.querySelector('div.bef-slider.ui-slider.ui-corner-all.ui-slider-horizontal.ui-widget.ui-widget-content');
        if (element !== null) {
          element_to_change = element.parentElement;
          element_to_change.style.backgroundSize = getStyle(element, 'left');
        }
        let observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === "attributes") {
              if (mutation.attributeName === 'style') {
                if (element !== null) {
                  element_to_change.style.backgroundSize = getStyle(element, 'left');
                }
              }
            }
          });
        });
        if (element !== null) {
          observer.observe(element, {
            attributes: true //configure it to listen to attribute changes
          });
        }
      });
    }
  };

})(jQuery, Drupal);
